<template>
	<!-- <div class="navigation">
		<div class="navigation-menu-tab">
			<ul>
				<li v-for="(item,index) in routes.filter(d=>d.meta.affix)" :key="index">
					<a href="javascript:;" :class="{'active':selectedMenu==item}" @click="selectedMenu=item">
						<icon :data-feather="item.meta.icon"></icon>
					</a>
				</li>
			</ul>
		</div>
		<div class="navigation-menu-body">
			<div class="navigation-menu-group">
				<div class="open" v-if="selectedMenu!=null">
					<ul>
						<li class="navigation-divider d-flex align-items-center">
							<icon class="mr-2" :data-feather="selectedMenu.meta.icon"></icon>
							{{selectedMenu.meta.title}}
						</li>
						<li v-for="(item,index) in selectedMenu.children.filter(d=>d.meta.affix)" :key="index">
							<router-link :to="{path:selectedMenu.path+'/'+item.path}" :class="{'active':selectedMenu.path+'/'+item.path==$route.path}">
								{{item.meta.title}}
							</router-link>
						</li>
						<li>
						<li class="navigation-divider">Summary</li>
						<li>
							<a href="#" class="d-flex align-items-start">
								<div>
									<figure class="avatar mr-3">
										<span class="avatar-title bg-danger rounded">
											<i class="ti-reload"></i>
										</span>
									</figure>
								</div>
								<div>
									<h6>待支付总额</h6>
									<h5 class="mb-0 font-weight-bold">￥{{paymoney}}</h5>
								</div>
							</a>
						</li>
					
						
						
            <li >
              <a href="#" class="d-flex align-items-start">
                <div>
                  <figure class="avatar mr-3" >
										<span class="avatar-title bg-success rounded" >
											<i class="ti-bar-chart-alt" ></i>
										</span>
                  </figure>
                </div>
                <div>
                  <h6>账户余额</h6>
                  <h5 class="mb-0 font-weight-bold">￥{{balance}}</h5>
                </div>
              </a>
            </li>
			<li>
				<a href="#" class="d-flex align-items-start">
					<div>
						<figure class="avatar mr-3">
							<span class="avatar-title bg-warning rounded">
								<i class="ti-bar-chart-alt"></i>
							</span>
						</figure>
					</div>
					<div>
						<h6>返利余额</h6>
						<h5 class="mb-0 font-weight-bold">￥{{flbalance}}</h5>
					</div>
				</a>
			</li>
					</ul>
				</div>
			</div>
		</div>

	</div> -->
</template>

<script>
	import Icon from '@/components/Icon.vue'
	import Homepage from '@/views/home/index.vue'
	import request from '@/utils/request'
	export default {
		components: {
			Icon,
			Homepage
		},
		data() {
			return {
				selectedMenu: null,
				pagination: {
					//默认每页显示的条数
					rows: 50,
					//默认显示第一页
					page: 1,
					//总数据条数
					records: 10,
					//总页数
					total: 5
				},
				
				records: '',
				records2: '',
				records3: '',
				sum:[],
				sum2:[],
				sum3:[],
      
        balance:'',
		flbalance:'',
		paymoney:'',
			}
		},
		computed: {
			'routes': vm => vm.$router.options.routes
		},
		created() {
			this.selectedMenu = this.routes.find(d => d.path == this.$route.matched[0].path),
			console.log(this.selectedMenu)
			this.getList(),
			this.getList2(),
			this.getList3(),
          this.getBalance()
		},
		methods: {
			handleNavigationClick(id) {
				this.selectedMainId = id
			},
			handleNavigationSubClick(id) {
				this.selectedSubId = id
			},
			//获取销售数据
						//全部
						getList() {
							request({
								url: 'DRPAPI.ashx?a=getorderlist',
								method: 'get',
								data: {
									pagination: JSON.stringify(this.pagination),
									queryJson: JSON.stringify(this.keyword)
								}
							}).then(res => {
								this.records = res.data.records
								var sum = 0
								for (var i = 0; i < res.data.rows.length; i++) {
									sum += res.data.rows[i].F_OrderAmount
								}
								this.sum = sum.toFixed(2)
							})
						},
						//待审核
						getList2() {
							request({
								url: 'DRPAPI.ashx?a=getorderlist',
								method: 'get',
								data: {
									pagination: JSON.stringify(this.pagination),
									queryJson: JSON.stringify(this.keyword2)
								}
							}).then(res => {
								this.records2 = res.data.records
								var sum2 = 0
								for (var i = 0; i < res.data.rows.length; i++) {
									sum2 += res.data.rows[i].F_OrderAmount
								}
								this.sum2 = sum2.toFixed(2)
							})
						},
						//待支付
						getList3() {
							request({
								url: 'DRPAPI.ashx?a=getorderlist',
								method: 'get',
								data: {
									pagination: JSON.stringify(this.pagination),
									queryJson: JSON.stringify(
										this.keyword3
									)
								}
							}).then(res => {
								this.records3 = res.data.records
								var sum3 = 0
								for (var i = 0; i < res.data.rows.length; i++) {
									sum3 += res.data.rows[i].F_OrderAmount
								}
								this.sum3 = sum3.toFixed(2)
							})
						},
      //账户余额
      getBalance() {
        request({
          url: 'DRPAPI.ashx?a=getpay',
          method: 'get',
          data: {
            pagination: JSON.stringify(this.pagination),
            queryJson: JSON.stringify(this.keyword4)
          }
        }).then(res => {
          if (res.info==''){
            this.yu=parseFloat(0)
          }else {
            this.yu=parseFloat(res.info)
          }
          request({
            url: 'DRPAPI.ashx?a=getincome',
            method: 'get'
          }).then(res => {
            if (res.info==''){
              this.yu2=parseFloat(0)
            }else {
              this.yu2 = parseFloat(res.info)
            }
            this.balance=res.data.balance,
			 this.flbalance=res.data.flbalance
			  this.paymoney=res.data.paymoney
            // console.log((this.sum+this.sum2).toFixed(2))
          })
        })


      },
		}
	}
</script>

<style>
	.layout-wrapper .content-wrapper .content-body .content
	{
		padding: 5px !important;
		padding-top: 65px !important;

	}
</style>
